import {Model} from '../Models';
import {DataTransferObject} from './DataTransferObject';
import {PaymentInfoDTO} from './PaymentInfoDTO';

export class SepaDTO extends PaymentInfoDTO {
  accountHolder: string = '';
  iban: string = '';
  bic: string = '';
  bankName: string = '';
  consent: boolean = false;

  fromData(data: any): SepaDTO {
    const dto = new SepaDTO();
    dto.accountHolder = data.accountHolder;
    dto.iban = data.iban;
    dto.bic = data.bic;
    dto.bankName = data.bankName;
    dto.consent = data.consent;
    return dto;
  }

  validate(): boolean {
    return this.validateField('accountHolder')
      && this.validateField('iban')
      && this.validateField('bic')
      && this.validateField('bankName')
      && this.validateField('consent');
  }

  validateField(field: string): boolean {
    switch (field) {
      case 'bankName':
        return this.bankName.length > 3
          && this.bankName.length < 128;
      case 'bic':
        return this.bic.length >= 8
          && this.bic.length <= 11;
      case 'accountHolder':
        return this.accountHolder.length > 3
          && this.accountHolder.length <= 128;
      case 'iban':
        return this.iban.length > 10
          && this.iban.length <= 34;
      case 'consent':
        return this.consent;
      default:
        return false;
    }
  }

  fromModel(model: Model): DataTransferObject {
    throw new Error('Not implemented');
  }
}
